import { render, staticRenderFns } from "./goodsPool.vue?vue&type=template&id=2203726b&scoped=true&"
import script from "./goodsPool.vue?vue&type=script&lang=js&"
export * from "./goodsPool.vue?vue&type=script&lang=js&"
import style0 from "./goodsPool.vue?vue&type=style&index=0&id=2203726b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203726b",
  null
  
)

export default component.exports